var React = require('react');

function To (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5 0A4.505 4.505 0 000 4.5c0 .999.638 2.629 1.951 4.981.929 1.664 1.842 3.051 1.88 3.109l.669 1.014.669-1.014c.038-.058.952-1.445 1.88-3.109C8.362 7.129 9 5.499 9 4.5 9 2.019 6.981 0 4.5 0zm0 6.802a2.333 2.333 0 110-4.666 2.333 2.333 0 010 4.666zm0 0"}));
}

To.defaultProps = {"width":"9","height":"13.604","viewBox":"0 0 9 13.604"};

module.exports = To;

To.default = To;
